import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { DialogBar } from '../../../components/common/DialogBar';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';

export const SubtopicThree = () => {
	const { loaded } = useSelector(state => state.menu)

	useEffect(() => {
		if (loaded) {
			ObserverEmitter.emit(EVENTS.subtopicThree.initScene, 0);
		}
	}, [loaded])
	return (
		<>
			<DialogBar
				callback={() => { }}
				dialog={"vienvenido subtema 3"}
				percentage={"100%"}
			></DialogBar>
		</>
	)
}
